import axios from "axios";
import { FETCH_ALL_SHIPPING_API } from "../Constants/Apis";

export const getShippings = async () => {
  try {
    return axios.get(FETCH_ALL_SHIPPING_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createShipping = async (payload) => {
  try {
    return axios.post(FETCH_ALL_SHIPPING_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const createShippingWithStock = async (shippingData, stockData) => {
  try {
    return axios.post(`${FETCH_ALL_SHIPPING_API}/with-stock`, {
      shippingData,
      stockData,
    });
  } catch (e) {
    return console.log(e);
  }
};

export const createShippingWithMutation = async (shippingData, stockData) => {
  return axios.post(`${FETCH_ALL_SHIPPING_API}/with-mutation`, {
    shippingData,
    stockData,
  });
};

export const updateShipping = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_SHIPPING_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateShippingSJ = async (sj, payload) => {
  try {
    return axios.put(`${FETCH_ALL_SHIPPING_API}/sj/${sj}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteShipping = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_SHIPPING_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

